import { useSelector } from "react-redux";

const initialState = {
  forms: window["appConfig"]
    ? window["appConfig"]().forms
      ? [...window["appConfig"]().forms]
      : []
    : [],
  selectedForm: null,
  selectedFormObject: null,
  selectedFeature: null,
  selectedLayer: null,
  selectedTab: "form",
  editMode: null,
  selectedSubmission: null,
  showNewButtons: true,
  maximumFeaturesPerForm: 1,
};

export default function formsReducer(state = initialState, action) {
  switch (action.type) {
    case "forms/select":
      {
        let newState = { ...state };

        newState.selectedForm = action.payload.form;

        if (action.payload.form) {
          newState.editMode = "new";
        } else {
          newState.editMode = null;
        }

        newState.selectedFormObject = action.payload.selectedFormObject;

        newState.selectedLayer = action.payload.layer;

        newState.selectedFeature = null;

        newState.showNewButtons =
          action.payload.selectedFormObject?.showNewButtons;

        newState.maximumFeaturesPerForm = action.payload.selectedFormObject
          ?.maximumFeaturesPerForm
          ? action.payload.selectedFormObject.maximumFeaturesPerForm
          : 1;

        return newState;
      }
      break;

    case "forms/update/editMode":
      {
        let newState = { ...state };

        newState.editMode = action.payload;

        return newState;
      }
      break;

    case "forms/update":
      {
        let newState = { ...state };

        newState.forms.forEach((el) => {
          if (el.form === action.payload.form) {
            el[action.payload.property] = action.payload.value;
          }
        });

        return newState;
      }
      break;

    case "forms/selectedTab":
      {
        let newState = { ...state };

        newState.selectedTab = action.payload;

        return newState;
      }
      break;

    case "forms/showNewButtons":
      {
        let newState = { ...state };

        newState.showNewButtons = action.payload;

        return newState;
      }
      break;

    case "forms/feature/select":
      {
        let newState = { ...state };

        newState.selectedFeature = action.payload;

        return newState;
      }
      break;

    case "forms/feature/select/submission":
      {
        let newState = { ...state };

        newState.selectedSubmission = action.payload;

        return newState;
      }
      break;

    case "forms/feature/add":
      {
        let newState = { ...state };

        newState[newState.selectedForm].push(action.payload);

        return newState;
      }

      break;

    case "forms/feature/update":
      {
        let newState = { ...state };

        newState[newState.selectedForm][action.payload.index] =
          action.payload.feature;

        return newState;
      }

      break;

    case "forms/feature/delete":
      {
        let newState = { ...state };

        newState[newState.selectedForm].splice(action.payload, 1);

        return newState;
      }

      break;

    default:
      return state;
  }
}
